const CURATION_CERTAINTY_THRESHOLD = 0.85

export default CURATION_CERTAINTY_THRESHOLD
